import {fetchAPI, generateUrl} from "api";
import {handleResponse} from "helpers/Requests";
import {deserializeEcgMeasurementWithPatient, ECG, IncomingEcgCount} from "../../../models/patient/measurement/ECG";
import {deserializeItem} from "../../../models/Helpers";
import {Queries} from "helpers/api/generateUrl";

const showIncomingECGsCount = () => {
  const url = generateUrl("/web/v1/measurements/ecgs/counts");

  return fetchAPI(url)
    .then(handleResponse<IncomingEcgCount>(deserializeItem));
};


function indexECGs(queries: Queries) {
  const url = generateUrl("/web/v1/measurements/ecgs", {}, queries);

  return fetchAPI(url).then(handleResponse<ECG[]>(deserializeEcgMeasurementWithPatient, true));
}


export {
  showIncomingECGsCount,
  indexECGs
};
